import { urlFor } from '../../utils/sanity';
import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
export default {
  name: 'SanityDivider',
  components: {
    SanityBlockContent
  },
  props: {
    content: {
      type: Array
    },
    styles: null
  },
  computed: {
    backgroundColor() {
      var _this$styles;
      return {
        backgroundColor: (_this$styles = this.styles) === null || _this$styles === void 0 ? void 0 : _this$styles.bgColor
      };
    },
    backgroundImage() {
      var _this$styles2;
      return {
        backgroundImage: 'url(' + urlFor((_this$styles2 = this.styles) === null || _this$styles2 === void 0 ? void 0 : _this$styles2.bgImage) + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      };
    },
    fontColor() {
      var _this$styles3;
      return {
        color: (_this$styles3 = this.styles) === null || _this$styles3 === void 0 ? void 0 : _this$styles3.color
      };
    }
  }
};